import { Injectable } from '@angular/core';
import { StorageKeys } from '../types/storage-keys';

@Injectable({
	providedIn: 'root',
})
export class StorageService {
	public getFromSessionStorage<T>(storageKey: StorageKeys): T | undefined {
		return this.get(storageKey, sessionStorage);
	}

	public setToSessionStorage<T>(storageKey: StorageKeys, value: T): void {
		this.set(storageKey, value, sessionStorage);
	}

	public removeFromSessionStorage(storageKey: StorageKeys): void {
		this.remove(storageKey, sessionStorage);
	}

	public clearSessionStorage(): void {
		this.clearStorage(sessionStorage);
	}

	public getFromLocalStorage<T>(storageKey: StorageKeys): T | undefined {
		return this.get(storageKey, localStorage);
	}

	public setToLocalStorage<T>(storageKey: StorageKeys, value: T): void {
		this.set(storageKey, value, localStorage);
	}

	public removeFromLocalStorage(storageKey: StorageKeys): void {
		this.remove(storageKey, localStorage);
	}

	public clearLocalStorage(): void {
		this.clearStorage(localStorage);
	}

	private get<T>(storageKey: StorageKeys, storage: Storage): T | undefined {
		const storedData: string | null = storage.getItem(storageKey);
		return storedData ? (JSON.parse(storedData) as T) : undefined;
	}

	private set<T>(storageKey: StorageKeys, dataToStore: T, storage: Storage): void {
		const dataAsString: string = JSON.stringify(dataToStore);
		return storage.setItem(storageKey, dataAsString);
	}

	private remove(storageKey: StorageKeys, storage: Storage): void {
		return storage.removeItem(storageKey);
	}

	private clearStorage(storage: Storage): void {
		return storage.clear();
	}
}
